import PropTypes from 'prop-types'
import RichText from '../../../../../shared/RichText'
import SvgIcon from '../../../../../shared/SvgIcon'

const ColumnToRowItem = ({ item, classNames }) => {
  return (
    <div
      className={`flex flex-equal flex-col items-center ${classNames}`}
      id={`column-to-row-item-${item.title}`}
      data-testid="column-to-row-item"
    >
      <SvgIcon name={item.logoName} className="h-20 w-20" />
      <h3
        id={item.title}
        className={`mt-5 whitespace-pre-line text-center text-lg font-medium lg:mt-4 lg:text-2xl`}
      >
        {item.title}
      </h3>
      <RichText
        contentData={item.description}
        className={`mt-4 max-w-80 text-center text-15 leading-170 text-gray-960 lg:mt-6 lg:min-h-16`}
      />
    </div>
  )
}

export default ColumnToRowItem

ColumnToRowItem.propTypes = {
  item: PropTypes.object.isRequired,
  classNames: PropTypes.string.isRequired,
}
